import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface SideWalksProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Sidewalks: React.FC<SideWalksProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [sidewalks, set_sidewalks] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Sidewalks'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Sidewalks': v } } })
    );
    const label = 'Sidewalks';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(sidewalks)}
                />
            ) : (
                <MoneyBox
                    id={'sidewalks'}
                    allowNegative={false}
                    value={sidewalks}
                    onChange={(value) => set_sidewalks(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
